// extracted by mini-css-extract-plugin
module.exports = {"list":"InspirationList_list__NGluY"};